export default "__VITE_ASSET__0b000eb7__"